import React, { useEffect } from "react";
import { Link } from "react-router-dom";

import { ShieldCheck } from "lucide-react";
import { UserAvatar } from "../../components/Component";
import { useUserInfo } from "../../layout/provider/Theme";

const UserProfileAside = ({ updateSm, sm }) => {
  const userInfo = useUserInfo()?.userInfo;

  useEffect(() => {
    sm
      ? document.body.classList.add("toggle-shown")
      : document.body.classList.remove("toggle-shown");
  }, [sm]);

  return (
    <div className="card-inner-group">
      <div className="card-inner">
        <div className="user-card">
          <UserAvatar text={userInfo?.name[0]} theme="primary" />
          <div className="user-info">
            <span className="lead-text">{userInfo?.name}</span>
            <span className="sub-text">{userInfo?.email}</span>
          </div>
        </div>
      </div>

      <div className="card-inner p-0">
        <ul className="link-list-menu">
          <li onClick={() => updateSm(false)}>
            <Link
              to={`${process.env.PUBLIC_URL}/user-profile-setting`}
              className={
                window.location.pathname ===
                ` d-flex  ${process.env.PUBLIC_URL}/user-profile-setting`
                  ? "active"
                  : ""
              }
            >
              <ShieldCheck size={20} style={{ paddingBottom: "5px" }} />
              <span className=" ps-1" style={{ paddingBottom: "3px" }}>
                Settings
              </span>
            </Link>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default UserProfileAside;
